module.exports = __webpack_public_path__ + "img/tYhfSjnh.b7e99680.png";